import React from 'react';
import { Image, Icon, useTheme } from '@zydalabs/storefront-components';
import { Typography, Button } from '@zydalabs/zac-react';
import { useResponsive } from 'common/hooks';
import styles from './style';

type Props = {
  title?: string;
  subTitle?: string;
  imageUrl?: string;
  iconColor?: string;
  buttonText?: string;
  fullHeight?: boolean;
  halfHeight?: boolean;
  onClick?: () => void;
  iconWidth?: string;
  icon?: () => React.ReactChild;
  isButtonFluid?: boolean;
};

const { StyledEmptyState, StyledEmptyStateContent, StyledEmptyStateAction } = styles;
const EmptyState: React.FC<Props> = ({
  title,
  subTitle,
  imageUrl,
  fullHeight,
  halfHeight,
  onClick,
  buttonText,
  icon,
  iconWidth = '24px',
  iconColor,
  isButtonFluid = false,
}) => {
  const theme: any = useTheme();
  const isLargeScreen = useResponsive(`min-width: ${theme.screenBreakpoints.extraLarge}`);
  return (
    <StyledEmptyState fullHeight={fullHeight} halfHeight={halfHeight} data-testid="empty-state">
      <StyledEmptyStateContent>
        {imageUrl && <Image imageUrl={imageUrl} />}

        {icon && <Icon icon={icon} color={iconColor} width={iconWidth} />}

        {title && (
          <Typography variant={isLargeScreen ? "heading24" : "heading16"} mt={`${theme.space[6]}px`} mb={0}>
            {title}
          </Typography>
        )}

        {subTitle && (
          <Typography variant="body16" mt={`${theme.space[2]}px`} >
            {subTitle}
          </Typography>
        )}

        {buttonText && onClick && (
          <StyledEmptyStateAction>
            <Button
              variant="ghost"
              onClick={onClick}
              isFluid={isButtonFluid}
              text={buttonText}
              testId="empty_cart_start_ordering_btn"
            />
          </StyledEmptyStateAction>
        )}
      </StyledEmptyStateContent>
    </StyledEmptyState>
  );
};

export default EmptyState;
